import { useEffect } from 'react';

function Home() {
  useEffect(() => {    
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);
  
  return (
    <></>
  );
}

export default Home;
